import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Icon, f7 } from 'framework7-react';
import { createFixedF7Tooltip } from '../helpers/tooltipUtils';

let infoTooltipSeq = 0;

/**
 * Inline (i) icon with tooltip. Desktop: hover; mobile: tap/click.
 * Tooltip is body-fixed so it is not clipped by scroll parents.
 */
export default function InfoTooltipIcon({ text, id, size = 21 }) {
  const autoIdRef = useRef(null);
  if (!autoIdRef.current) {
    infoTooltipSeq += 1;
    autoIdRef.current = `info_tooltip_${infoTooltipSeq}`;
  }
  const targetId = id || autoIdRef.current;
  const tipRef = useRef(null);

  useEffect(() => {
    if (!text || !f7) {
      return undefined;
    }
    const targetEl = document.getElementById(targetId);
    if (!targetEl) {
      return undefined;
    }

    tipRef.current = createFixedF7Tooltip(f7, {
      targetEl,
      text,
      clickable: true,
      cssClass: 'info-tooltip',
      showDelay: window.isDesktop ? 200 : 0
    });

    return () => {
      if (tipRef.current?.destroy) {
        tipRef.current.destroy();
      }
      tipRef.current = null;
    };
  }, [text, targetId]);

  if (!text) {
    return null;
  }

  return (
    <span
      id={targetId}
      className="info-tooltip-icon"
      role="button"
      tabIndex={0}
      aria-label={text}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.currentTarget.click();
        }
      }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 6,
        verticalAlign: 'middle',
        cursor: 'pointer',
        color: '#889cb2',
        lineHeight: 1
      }}
    >
      <Icon material="info_outline" size={size} />
    </span>
  );
}

InfoTooltipIcon.propTypes = {
  text: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.number
};
